<template>
  <div class="core__group-container">
    <div
      v-for="(groupChunk, index) of items"
      :key="`group-${elem.id}-${index}`"
      class="core__group"
    >
      <div
        class="core__group-chunk"
        :class="{ 'mobile-group': groupChunk.isMobile }"
      >
        <TheContent
          v-for="item of groupChunk.chunk"
          :key="item.id"
          :elem="item"
          :lazy-loading-enabled="true"
        />
      </div>
      <!-- Переделываем figcaption на span для семантики-->
      <TheContent
        v-if="groupChunk.isMobile && groupChunk.chunkCaption"
        :key="groupChunk.chunkCaption.id"
        :elem="{ ...groupChunk.chunkCaption, type: 'span' }"
      />
      <TheContent
        v-if="groupChunk.isMobile && groupChunk.chunkDescription"
        :key="groupChunk.chunkDescription.id"
        :elem="groupChunk.chunkDescription"
      />
    </div>
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import TheContent from '~/components/content/TheContent';

  interface GroupChunk {
    chunk: TContent[];
    chunkCaption?: TContent;
    chunkDescription?: TContent;
    isMobile: boolean;
  }

  export default defineNuxtComponent({
    name: 'CoreGroup',

    components: {
      TheContent,
    },

    props: {
      elem: {
        type: Object as PropType<TContent>,
        required: true,
      },
    },

    computed: {
      items(): GroupChunk[] {
        const children = this.elem.children;

        const chunkSize = 2;
        const result = [];

        for (let i = 0; i < children.length; i += chunkSize) {
          let isMobile = false;
          // У группы может быть только одна подпись и описание,
          // потому находим первое описание и подпись у элементов
          let chunkCaption: TContent | undefined;
          let chunkDescription: TContent | undefined;

          const chunk = [];

          for (let j = 0; j < chunkSize; j++) {
            const item = children[j];

            if (!item) {
              continue;
            }

            // Проверяем описание элемента, если еще не сохранено для группы то сохраняем его
            chunkDescription = chunkDescription || item.children.find((elem) => elem.type === 'p');
            const figureWrapper =
              item.type === 'figure' ? item : item.children.find((elem) => elem.type === 'figure');

            if (figureWrapper) {
              // Проверяем подпись элемента, если еще не сохранено для группы то сохраняем его
              chunkCaption =
                chunkCaption || figureWrapper.children.find((elem) => elem.type === 'figcaption');

              // Проверяем оба ли элемента внутри группы мобильные скриншоты
              isMobile = figureWrapper.children.some((elem) =>
                elem?.attributes.class?.includes('mobile-border-wrapper'),
              );
            }

            chunk.push(item);
          }

          result.push({
            chunk,
            chunkCaption,
            chunkDescription,
            isMobile: isMobile && chunk.length >= 2,
          });
        }

        return result;
      },
    },
  });
</script>

<style lang="scss" scoped>
  .core__group {
    margin: 24px 0;

    figcaption {
      margin-top: 8px;
    }

    &-chunk {
      display: flex;
      gap: 6px;
    }

    > *,
    &-chunk > * {
      margin: 0;
    }
  }

  .mobile-group {
    display: flex;
    flex-direction: column;
    background-color: #eeeeee;
    text-align: center;
    justify-content: center;
    gap: 12px;
    padding: 12px 16px;

    ~ p {
      @include fontSmallText;
    }

    // Скрываем подпись и описание через css чтобы не модифицировать элементы
    p,
    figcaption {
      display: none;
    }

    .image-with-description {
      figure {
        margin: 0;
      }
    }

    @include tablet {
      flex-direction: row;
      gap: 16px;
      padding: 16px;
    }

    @include tablet {
      :first-child > div {
        justify-content: right;
      }

      :not(:first-child) > div {
        justify-content: left;
      }
    }

    * {
      margin: 0;
      padding: 0;
    }
  }
</style>
